module.exports = __webpack_public_path__ + "static/media/cart-page-congratulation-page.10510a78.png";